(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('prop-types')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types'], factory) :
  (global = global || self, factory(global.PageReady = {}, global.React, global.PropTypes));
}(this, (function (exports, React, PropTypes) { 'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;
  PropTypes = PropTypes && Object.prototype.hasOwnProperty.call(PropTypes, 'default') ? PropTypes['default'] : PropTypes;

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  var bpfrpt_proptype_RequestShape = {
    fetching: PropTypes.bool.isRequired,
    failed: PropTypes.bool.isRequired,
    success: PropTypes.bool.isRequired,
    payload: function payload(props, propName, componentName) {
      if (!Object.prototype.hasOwnProperty.call(props, propName)) {
        throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
      }
    }
  };
  var request = {
    fetching: false,
    failed: false,
    success: false,
    payload: null
  };

  var PageReadyContext = /*#__PURE__*/React.createContext({
    data: null
  });
  /**
   * PageReady is a component that triggers a request promise and manages it's state based on the promise state
   * it's commonly used to provide a standard wrapper for triggering requests when a component is mounted
   */

  var PageReady = /*#__PURE__*/function (_React$Component) {
    _inherits(PageReady, _React$Component);

    var _super = _createSuper(PageReady);

    function PageReady(props) {
      var _this;

      _classCallCheck(this, PageReady);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "getPageReadyContent", function () {
        var request = _this.props.predefinedAction ? _this.props.predefinedAction.request : _this.state;

        if (request.success) {
          return _this.props.children;
        }

        if (request.fetching) {
          return _this.props.renderCustomLoader() || /*#__PURE__*/React.createElement("div", null, "LOADING");
        }

        if (request.failed) {
          return /*#__PURE__*/React.createElement("div", {
            className: "page-ready__content"
          }, _this.props.customErrorMessage || request.message);
        }

        return null;
      });

      _defineProperty(_assertThisInitialized(_this), "initRequest", function () {
        if (_this.props.predefinedAction) {
          _this.props.predefinedAction.dispatch();
        } else {
          _this.setState(_objectSpread2(_objectSpread2({}, request), {}, {
            // eslint-disable-next-line
            fetching: true
          }));

          _this.props.getRequestInstance().then(function (data) {
            if (_this.props.onData) {
              _this.props.onData(data);
            }

            _this.setState(_objectSpread2(_objectSpread2({}, request), {}, {
              // eslint-disable-next-line react/no-unused-state
              success: true,
              data: data
            }));
          }).catch(function (err) {
            if (_this.props.customErrorHandler) {
              var status = err.status,
                  data = err.data;

              _this.props.customErrorHandler(status, data);
            }

            _this.setState(_objectSpread2(_objectSpread2({}, request), {}, {
              // eslint-disable-next-line react/no-unused-state
              failed: true,
              // eslint-disable-next-line react/no-unused-state
              message: _this.props.errorMessageInterpreter(err)
            }));
          });
        }
      });

      _this.state = _objectSpread2(_objectSpread2({}, request), {}, {
        data: null
      });
      return _this;
    }

    _createClass(PageReady, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.initRequest();
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(PageReadyContext.Provider, {
          value: {
            data: this.state.data
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "page-ready"
        }, this.getPageReadyContent()));
      }
    }]);

    return PageReady;
  }(React.Component);

  _defineProperty(PageReady, "defaultProps", {
    onData: function onData() {
      return true;
    },
    customErrorMessage: 'Failed to load',
    predefinedAction: null,
    customErrorHandler: function customErrorHandler() {
      return null;
    },
    renderCustomLoader: function renderCustomLoader() {
      return null;
    },
    errorMessageInterpreter: function errorMessageInterpreter() {
      return 'Error receiving Data';
    }
  });

  _defineProperty(PageReady, "propTypes", {
    /** dispatch action for store */
    predefinedAction: PropTypes.object,

    /** function that returns an promise. on success, the promise has the data from request */
    getRequestInstance: PropTypes.func.isRequired,

    /** Triggers when promise is successful. in the function's parameter, it will
     * have data from the promise */
    onData: PropTypes.func,

    /** String to display custom error message */
    customErrorMessage: PropTypes.string,

    /** this function triggers on catch of error from the Promise of `getRequestInstance`.  */
    customErrorHandler: PropTypes.func,

    /** Renders custom loader if set */
    renderCustomLoader: PropTypes.func,
    errorMessageInterpreter: PropTypes.func
  });

  exports.PageReadyContext = PageReadyContext;
  exports.default = PageReady;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
